import React, { useState, useEffect, useRef } from 'react';
import { Header, Footer } from './Container';
import { Container, Row, Button, Form } from "react-bootstrap";
import '../assets/css/Cogen.css';
import { ReqGet, ReqPost } from "../config/Requests";
import { useLocation } from "react-router-dom";

function QAForum() {
    const isLogin = localStorage.getItem("isLogin");
    const userType = (isLogin) ? localStorage.getItem("userType") : "public";
    const profile = JSON.parse(localStorage.getItem("profile"))
    const [messages, setMessages] = useState([]);
    const ref = useRef();
    useEffect(() => {
        if (userType.toLowerCase() === 'member') {
            ReqGet('messages/thread/' + job.thread_id).then(res => {
                setMessages(res.data.messages);
            })

                .catch(err => console.log(err.response))
        } else if (userType.toLowerCase() === 'client') {
            ReqGet(`messages/thread/${job.id}/member/${member}`).then(res => {
                setMessages(res.data.messages);
            })

                .catch(err => console.log(err.response))
        }

    }, []);
    const postQuestion = () => {
        ReqPost(`job/${job.id}/question`, { comment: ref.current.value }).then((res) => {
            if (res.status === 500 ) {
                  alert(res.data.message);
            } else {
                window.location.reload();
            }
        }).catch((err) => {
            console.log("Erorrr......................", err)
        })
    }

    const postAnswer = (member) => {
        ReqPost(`answer/job/${job.id}/member/${member}`, { answer: ref.current.value }).then(() => {
            window.location.reload();
        }).catch((err) => {
            alert(err.message);
        })
    }

    const submitForm = () => {
        if (userType.toLowerCase() === 'member') {
            postQuestion();
        } else if (userType.toLowerCase() === 'client') {
            postAnswer(member);
        }
    }

    const location = useLocation();
    const { job, member } = location.state.params;

    const messageBody = (message) => {
        if (userType.toLowerCase() === 'client') {
            if (profile.id === message.participable_id) {
                return (
                    <Row>
                        <h6 className="msg-header">Me: </h6>
                        <p className="msg-body"> {message.body} </p>
                    </Row>
                )
            } else {
                return (
                    <Row>
                        <h6 className="msg-header">Member: </h6>
                        <p className="msg-header"> {message.body} </p>
                    </Row>
                )
            }
        } else if (userType.toLowerCase() === 'member') {
            if (profile.id === message.participable_id) {
                return (
                    <Row>
                        <h6 className="msg-header">Me: </h6>
                        <p className="msg-body"> {message.body} </p>
                    </Row>
                )
            } else {
                return (
                    <Row>
                        <h6 className="msg-header">Client: </h6>
                        <p className="msg-header"> {message.body} </p>
                    </Row>
                )
            }
        }
    }
    console.log(userType);
    return (
        <Container fluid="true">
            <Header type="member" />
            <Container className="flex-column mt-5 notification align-content-inherit">
                <h2>Question/Answers</h2>
                {typeof messages !== 'undefined' ? messages.map((item) => {
                    return (
                        messageBody(item)
                    )
                }) : null}
                <Form>
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Reply:</Form.Label>
                        <Form.Control ref={ref} as="textarea" rows={3} />
                        <br />
                        <Button variant="primary" onClick={submitForm}>Submit</Button>

                    </Form.Group>
                </Form>
            </Container>
            <Footer />
        </Container>
    );
}
export default QAForum;